// validates if a parameter is a number and returns that number, otherwise returns paramDefault

export default (el, paramSelector, valueDefault = 0) => {
	const paramValue = el.getAttribute(paramSelector);
	const paramValueFloat = parseFloat(paramValue);

	if (!isNaN(paramValueFloat)) {
		return paramValueFloat;
	}

	return valueDefault;
};
